import styled from 'styled-components';

export const CategoryDescriptionStyled = styled.div``;

export const NameContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 10px;
  margin-bottom: 10px;
  h3 {
    margin: 0;
  }
`;

export const Input = styled.input`
  ${(props) => props.theme.newTypography.textStyleDisplayMedium};
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N800
      : props.theme.atlas.semantic.color.type.default};
  border: none;
  word-break: break-word;
  min-width: 175px;
  width: 500px;

  &::placeholder {
    color: ${(props) =>
      props.theme.isVaultVariant
        ? props.theme.newPalette.neutral.N600
        : props.theme.atlas.semantic.color.type.muted};
  }

  &:focus-visible {
    outline: none;
  }
`;
